let trackingWindow = window as any;

export function track(payload: any) {
	trackingWindow.dataLayer = trackingWindow.dataLayer || [];
	trackingWindow.dataLayer.push(payload);
}

export function trackEcommerce(payload: any) {
	track({
		ecommerce: null,
	});
	track(payload);
}